import React, { useContext, useEffect, useState } from "react";
import Beneficiary from "./beneficiary";
import styles from "./styles/inheritance.module.css";
import You from "./you";
import Add from "./add";
import { UserData } from "../../../Context/DataContext";
import NewBeneficiary from "../Add Beneficiary/new_beneficiary";
import EditBeneficiary from "../Edit Beneficiary/edit_beneficiary";
import { formatTime } from "../../../Utils/formatTime";
import FrequencyPicker from "./FrequencyPicker";
import { useRef } from "react";
import { updateDelays } from "../../../Utils/inheritance";
import groupImg from "./styles/img/group.png";
import { useLocation } from "react-router-dom";
import Info from "../Info/info";
import { floatMessage } from "../../../Utils/floatMessage";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import {
  handleBackClick,
  handleNextClick,
  handleCloseClick,
} from "../../../Utils/onboardingButtons";
import { beneficiaryDelayTimeOptions } from "../../../Utils/timeOptions";
import LegalData from "./legalData";
import PromotionData from "./promotionData";
import { active } from "../../../Utils/partnerApproval";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

function Tree({ assets, beneficiaries, trustees, keep_alive = 0 }) {
  const one_day = 24 * 60 * 60 * 1000;
  const [delay1, setDelay1] = useState(false);
  const [delay2, setDelay2] = useState(false);
  const userData = UserData();
  /*
    True only inside the partner's view of a customer's tree.

    What it hides is everything on this page that is not a beneficiary card: the
    "You" block with the customer's own picture, phone number and keep-alive
    settings, and the two priority delays. None of those has a sharing flag, so
    the server never sends them and there is nothing here to draw -- see
    sharedCustomer.js, where every one of them is a deliberate empty.

    The delays are hidden rather than shown read-only for the same reason: a
    partner reading "0 Days" would be reading a value the customer never
    shared, not the one they set.

    The "You" card itself stays: its asset, beneficiary and advisor counts are
    of the shared records only, which is exactly what a partner should see. The
    personal settings inside it are hidden by You itself.
  */
  const partnerReadOnly = Boolean(userData.partnerReadOnly);
  const hidden = partnerReadOnly ? { display: "none" } : undefined;
  const [modal, setModal] = useState();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  /*
    Someone sent only because a shared asset names them is not a record the
    customer shared -- their name labels that asset and nothing more -- so the
    tree leaves them out, and the You card does not count them. Everything the
    customer shared outright is unaffected, and on their own account nothing
    carries the flag at all. Same rule the advisors tab applies.
  */
  const records = (list) =>
    (list || []).filter((r) => r?.shared_as_record !== false);
  const listedBeneficiaries = records(userData.UserData.beneficiaries);
  const [data, setData] = useState(listedBeneficiaries);
  const [toEdit, setToEdit] = useState(data);
  const [priority, setPriority] = useState(1);
  const wrapperRef = useRef(null);
  const wrapperRef1 = useRef(null);
  const { height, width } = useWindowDimensions();
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.InheritanceTree.Tree
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.InheritanceTree.Tree);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  // onboarding popups
  const isFirstLogin = userData.CustomerUser.first_login;

  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash === "") {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);

        if (element) {
          var innerHeight_Half = window.innerHeight >> 1;
          var elementRect = element.getBoundingClientRect();

          window.scrollBy(
            elementRect.left >> 1,
            elementRect.top - innerHeight_Half
          );
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  useEffect(() => {
    setData(records(userData.UserData.beneficiaries));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.UserData.beneficiaries, openAdd, openEdit]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDelay1(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef1.current && !wrapperRef1.current.contains(event.target)) {
        setDelay2(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef1]);
  const updateDelay = (priority, new_delay) => {
    const new_user_data = updateDelays(priority, new_delay, userData.UserData);
    userData.setUserData(new_user_data);
    setDelay1(false);
    setDelay2(false);
    floatMessage(dublicatedcontent?.saved);
  };

  const priorityOne = `level_main_${
    data.filter((e) => e.priority === "1").length
  }`;
  const priorityOneClass = styles[priorityOne];

  const priorityTwo = `level_main_${
    data.filter((e) => e.priority === "2").length
  }`;
  const priorityTwoClass = styles[priorityTwo];

  const beneficiariesOne = data.filter((e) => Number(e.priority) === 1);
  const beneficiariesTwo = data.filter((e) => Number(e.priority) === 2);

  return (
    <>
      {width < 1200 && (
        <div className={styles.promotionMobileContainer}>
          {(userData.userValidationData?.prefilled_customer_data_type ===
            "promotion" ||
            userData.promotionData?.show_promotion) && (
            <div
              style={{
                width: width < 650 ? "100vw" : "max-content",
                backgroundColor: "white",
                margin: "0 auto 20px",
                padding: "10px",
                boxShadow: "var(--box-shadow)",
                borderRadius: "var(--border-radius)",
              }}
            >
              <PromotionData />
            </div>
          )}
        </div>
      )}

      <div className={styles.main}>
        <span className={styles.inheritance_title}>{content.treeTitle1}</span>
        <div className={styles.rect_small}></div>
        {width >= 1200 &&
          (userData.userValidationData?.prefilled_customer_data_type ===
            "promotion" ||
            userData.promotionData?.show_promotion) && <PromotionData />}

        <div className={styles.you}>
          {/* {width > 1024 ? (
          legalData.length ? (
            <AddNotary
              legal_type={
                dublicatedcontent[
                  legalData[0]?.type?.replace(/\s/g, "")?.toLowerCase()
                ]
              }
            />
          ) : (
            <AddLeft
              disabled={userData.isFreezed}
              text={content.treeText1}
              message={content.treeText2}
              color={"#26323E"}
              onClick={() => {
                setModal(<AddNotaryPopUp onClose={() => setModal()} />);
              }}
            />
          )
        ) : (
          <></>
        )} */}

          <div
            style={{
              position: "relative",
              display: "flex",
              width: "100%",
            }}
          >
            {/* the new design of legal advisor */}
            <div
              style={{
                margin: "0 auto",
                position: "relative",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {(userData.UserData.legal?.length > 0 ||
                userData.userValidationData?.prefilled_customer_data_type ===
                  "legal") &&
                ((userData.CustomerUser?.show_legal_data &&
                  userData.CustomerUser?.user_type.toLowerCase() !==
                    "partner") ||
                  userData.userValidationData?.prefilled_customer_data_type ===
                    "legal") && <LegalData setModal={setModal} />}

              {/*
                The counts are of what actually works. A partner-created record
                awaiting approval is not part of the mechanism yet, so counting
                it here would tell the customer they have four beneficiaries
                when only three of them inherit.
              */}
              <You
                profile_avatar={userData.UserData?.profile_avatar}
                assets={active(userData.UserData?.assets).length}
                /*
                  Records only, both of them. Someone here just to label a
                  shared asset is not a beneficiary or an advisor the customer
                  gave their partner -- counting them says the customer has
                  more of each than they shared. The advisor count has been
                  wrong since asset-linked advisors were added.
                */
                beneficiaries={active(records(userData.UserData?.beneficiaries)).length}
                trustees={active(records(userData.UserData?.trustees)).length}
                keep_alive={formatTime(
                  userData.UserData.keep_alive_timeout,
                  dublicatedcontent
                )}
              />
            </div>
          </div>

          {/* Old tree design */}
          {/* <div
          style={
            width > 1024
              ? {
                  display: "flex",
                  alignItems: "center",
                }
              : width > 750
              ? {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }
              : {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexDirection: "column",
                  gap: "30px",
                  alignItems: "center",
                }
          }
        >
          {width <= 1024 ? (
            legalData.length ? (
              <AddNotary
                legal_type={
                  dublicatedcontent[
                    legalData[0]?.type?.replace(/\s/g, "")?.toLowerCase()
                  ]
                }
              />
            ) : (
              <AddLeft
                disabled={userData.isFreezed}
                text={content.treeText1}
                message={content.treeText2}
                color={"#26323E"}
                onClick={() => {
                  setModal(<AddNotaryPopUp onClose={() => setModal()} />);
                }}
              />
            )
          ) : (
            <></>
          )}
          {userData?.CustomerUser?.self_recovery_id_private_key ? (
            <SelfRecovery />
          ) : (
            <Add
              disabled={userData.isFreezed}
              text={content.treeText3}
              message={content.treeText4}
              color={"#26323E"}
              onClick={() => {
                setModal(<SelfRecoveryPopUp onClose={() => setModal()} />);
              }}
            />
          )}
        </div> */}
        </div>
        <div className={styles.keep_alive_sub} style={hidden}>
          {content.treeText5}
        </div>
        <div className={styles.inheritance_wrap}>
          <div className={styles.rect}>
            <div className={styles.inheritance_circle} />
          </div>
          <div className={styles.priority_level}>
            {isFirstLogin && (
              <div className="hint_popup hint_popup_priority" id="4">
                <div className="hint_text">{content.treeText6}</div>
                <div className="hint_actions">
                  <button
                    onClick={handleBackClick}
                    className="hint_btn hint_btn--back"
                  >
                    {dublicatedcontent.dublicatedText71}
                  </button>
                  <div className="hint_counter">5/6</div>
                  <button
                    onClick={handleNextClick}
                    className="hint_btn hint_btn--next"
                  >
                    {dublicatedcontent.dublicatedText72}
                  </button>
                </div>
                <button
                  onClick={() => handleCloseClick(userData)}
                  className="close_hint_btn"
                ></button>
              </div>
            )}
            <span>{content.treeText9}</span>
            <Info message={content.treeText10} />
          </div>
          <div className={styles.subtitle}>{content.treeText11}</div>
          <div
            id="priority1"
            ref={wrapperRef}
            className={
              userData.isFreezed ? styles.days_main_disabled : styles.days_main
            }
            style={{ position: "relative", ...(hidden || {}) }}
          >
            <div style={{ display: "flex" }}>
              <center
                onClick={() => setDelay1(!delay2)}
                className={styles.days_center}
              >
                {
                  formatTime(
                    userData.UserData.inheritance_parameters.priority_one_delay,
                    dublicatedcontent
                  ).split(" ")[0]
                }
              </center>
              <div className={styles.days_right}>
                {
                  formatTime(
                    userData.UserData.inheritance_parameters.priority_one_delay,
                    dublicatedcontent
                  ).split(" ")[1]
                }
                <Info message={content.treeText12} />
              </div>
            </div>
            <div style={{ width: "fit-content", margin: "0 auto" }}>
              {delay1 && (
                <FrequencyPicker
                  disabled={userData.isFreezed}
                  time_options={beneficiaryDelayTimeOptions.filter((freq) =>
                    userData.CustomerUser.self_recovery_key
                      ? freq >
                        userData.UserData.inheritance_parameters.self_recovery
                      : true
                  )}
                  OnSelect={(e) => updateDelay("one", e)}
                  timeContent={dublicatedcontent}
                />
              )}
            </div>
          </div>
          <div className={`${styles.level_main} ${priorityOneClass}`}>
            {width > 977 &&
            data.filter((e) => Number(e.priority) === 1).length > 0 ? (
              <div className={styles.add_div}>
                <Add
                  disabled={userData.isFreezed}
                  level={1}
                  visibility={"hidden"}
                />
              </div>
            ) : null}
            <div className={styles.tree_level}>
              {data
                .filter((e) => Number(e.priority) === 1)
                .map((beneficiary) => {
                  return (
                    <Beneficiary
                      key={beneficiary.user_id}
                      onEdit={() => {
                        setToEdit(beneficiary);
                        setOpenEdit(true);
                      }}
                      beneficiary={beneficiary}
                      priority={beneficiary.priority}
                    />
                  );
                })}
            </div>
            {/* maximim amount of beneficiaries per priority level: 6 */}
            {beneficiariesOne.length < 6 && beneficiariesOne.length !== 0 ? (
              <Add
                disabled={userData.isFreezed}
                level={1}
                onClick={() => {
                  setPriority(1);
                  setOpenAdd(true);
                }}
              />
            ) : null}

            {beneficiariesOne.length === 0 ? (
              <div className={styles.add_new}>
                <img src={groupImg} className={styles.group_img} />
                <div className={styles.add_new_text}>{content.treeText13}</div>
                <Add
                  disabled={userData.isFreezed}
                  level={1}
                  classname={"new"}
                  onClick={() => {
                    setPriority(1);
                    setOpenAdd(true);
                  }}
                />
              </div>
            ) : null}
          </div>
          <div className={styles.subtitle}>{content.treeText14}</div>
          <div className={styles.rect}>
            <div className={styles.inheritance_circle} />
          </div>
          <div className={styles.priority_level}>
            {isFirstLogin && (
              <div className="hint_popup hint_popup_priority" id="5">
                <div className="hint_text">{content.treeText15}</div>
                <div className="hint_actions">
                  <button
                    onClick={handleBackClick}
                    className="hint_btn hint_btn--back"
                  >
                    {dublicatedcontent.dublicatedText71}
                  </button>
                  <div className="hint_counter">6/6</div>
                  <button
                    onClick={handleNextClick}
                    className="hint_btn hint_btn--next"
                  >
                    {dublicatedcontent.dublicatedText72}
                  </button>
                </div>
                <button
                  onClick={() => handleCloseClick(userData)}
                  className="close_hint_btn"
                ></button>
              </div>
            )}
            <span>{content.treeText16}</span>
            <Info message={content.treeText17} />
          </div>
          <div className={styles.subtitle}>{content.treeText18}</div>
          <div
            id="priority2"
            ref={wrapperRef1}
            className={
              userData.isFreezed ? styles.days_main_disabled : styles.days_main
            }
            style={{ position: "relative", ...(hidden || {}) }}
          >
            <div style={{ display: "flex" }}>
              <center
                onClick={() => setDelay2(!delay2)}
                className={styles.days_center}
              >
                {
                  formatTime(
                    userData.UserData.inheritance_parameters.priority_two_delay,
                    dublicatedcontent
                  ).split(" ")[0]
                }
              </center>
              <div className={styles.days_right}>
                {
                  formatTime(
                    userData.UserData.inheritance_parameters.priority_two_delay,
                    dublicatedcontent
                  ).split(" ")[1]
                }
                <Info message={content.treeText19} />
              </div>
            </div>
            <div style={{ width: "fit-content", margin: "0 auto" }}>
              {delay2 && (
                <FrequencyPicker
                  time_options={beneficiaryDelayTimeOptions}
                  OnSelect={(e) => updateDelay("two", e)}
                  timeContent={dublicatedcontent}
                />
              )}
            </div>
          </div>
          <div
            className={`${styles.level_main} ${styles.level_main_last} ${priorityTwoClass}`}
          >
            {data.filter((e) => Number(e.priority) === 2).length > 0 ? (
              <div className={styles.add_div}>
                <Add
                  disabled={userData.isFreezed}
                  level={1}
                  visibility={"hidden"}
                />
              </div>
            ) : null}
            <div className={styles.tree_level}>
              {data
                .filter((e) => Number(e.priority) === 2)
                .map((beneficiary) => {
                  return (
                    <Beneficiary
                      key={beneficiary.user_id}
                      onEdit={() => {
                        setToEdit(beneficiary);
                        setOpenEdit(true);
                      }}
                      beneficiary={beneficiary}
                      priority={beneficiary.priority}
                    />
                  );
                })}
            </div>

            {/* maximim amount of beneficiaries per priority level: 6 */}
            {beneficiariesTwo.length < 6 && beneficiariesTwo.length !== 0 ? (
              <Add
                disabled={userData.isFreezed}
                level={2}
                onClick={() => {
                  setPriority(2);
                  setOpenAdd(true);
                }}
              />
            ) : null}

            {beneficiariesTwo.length === 0 ? (
              <div className={styles.add_new}>
                <img src={groupImg} className={styles.group_img} />
                <div className={styles.add_new_text}>{content.treeText20}</div>
                <Add
                  disabled={userData.isFreezed}
                  level={2}
                  classname={"new"}
                  onClick={() => {
                    setPriority(2);
                    setOpenAdd(true);
                  }}
                />
              </div>
            ) : null}
          </div>

          <div style={{ zIndex: 6 }}>
            {openAdd ? (
              <NewBeneficiary
                onClose={() => setOpenAdd(false)}
                priority={priority}
              />
            ) : null}
            {openEdit ? (
              <EditBeneficiary
                toEdit={toEdit}
                onClose={() => setOpenEdit(false)}
              />
            ) : null}
            {modal ? modal : null}
          </div>
        </div>
        {isFirstLogin && (
          <div className="hint_popup hint_popup_finish no-arrow" id="6">
            <div className="hint_text">
              <div className="hint_title">{content.treeText21}</div>
              {content.treeText22}
              <a
                className="hint_link"
                href="https://ostreon.io/blog/estate-planning.html"
                target="_blank"
                rel="noreferrer"
              >
                {content.treeText23}
              </a>
            </div>
            <div className="hint_actions">
              <button
                onClick={handleBackClick}
                className="hint_btn hint_btn--back"
              >
                {dublicatedcontent.dublicatedText71}
              </button>
              <button
                onClick={() => handleCloseClick(userData)}
                className="hint_btn hint_btn--finish"
              >
                {content.treeText24}
              </button>
            </div>
            <button
              onClick={() => handleCloseClick(userData)}
              className="close_hint_btn"
            ></button>
          </div>
        )}
      </div>
    </>
  );
}

export default Tree;
